import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React from "react";
import { Link } from "react-router-dom";

/**
 * Styled Link to all items.
 */
export function SeeAllLink(props: { href: string; text: string }) {
  const { href, text } = props;

  return (
    <div className="flex justify-center border-t pt-2 mt-8">
      <Link to={href} className="font-semibold text-black no-underline">
        {text} <ArrowForwardIosIcon className="text-sm" />
      </Link>
    </div>
  );
}
